import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 按需引入element-ui
import './utils/element'
// 引入全局样式
import './utils/public.less'
// const postcssConfig = require('../postcss.config.js')
// console.log(postcssConfig);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
